// S3DEV2-7476: helpers for reading the backend's per-product-line walk-in breakdown.
// The API returns a `walk_in_orders_by_line` array alongside the existing scalar
// walk-in total; each element is { product_line_id, product_line, count, revenue? }.
// The scalar total remains the sum of all lines for backward compatibility.

export const PRODUCT_LINE_ID = {
  CPAP: 1,
  CGM: 2
};

// Reverse of PRODUCT_LINE_ID: { 1: "CPAP", 2: "CGM" }, for displaying the
// numeric product_line id the walk-in API returns on the patient chart.
export const PRODUCT_LINE_NAME = Object.fromEntries(
  Object.entries(PRODUCT_LINE_ID).map(([name, id]) => [id, name])
);

// Human-readable name for a product line id; "" when the id is unknown/missing.
export const productLineNameForId = id => PRODUCT_LINE_NAME[id] ?? "";

// Count for a specific product line id; 0 when that line has no walk-ins (or the
// array is missing, e.g. an older API response). Coerces product_line_id so a
// string id in the response ("1") still matches the numeric line constants.
export const walkInCountForLine = (byLine, productLineId) =>
  (byLine || []).find(x => Number(x.product_line_id) === productLineId)?.count ??
  0;

export const cpapWalkInCount = byLine =>
  walkInCountForLine(byLine, PRODUCT_LINE_ID.CPAP);

export const cgmWalkInCount = byLine =>
  walkInCountForLine(byLine, PRODUCT_LINE_ID.CGM);
